
export const MIXPANEL_TOKEN = "4bd8393c8dca1eaab5ae007c58c657f4";